// extracted by mini-css-extract-plugin
module.exports = {"agesContainer":"AgeSelector_agesContainer__zFP0n"};